/**
 * @class TintometricSystem
 */
export default class TintometricSystem {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  code
     */
    constructor(id, name, code) {
        this._id = id;
        this._name = name;
        this._code = code;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Tintometric system");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number}  id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String}  name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get code() {
        return this._code;
    }

    /**
     * @param {String} code
     */
    set code(code) {
        this._code = code;
    }
}
